import React, { FC, useEffect, useState } from "react";
import { Form, Button, Spin, Row, Input, DatePicker } from "antd";
import { useSelector } from "react-redux";
import { Collapse } from "antd";
import { RootState } from "../../../store/store";
import { Col } from "antd";
import WithoutReferral from "../PreAuth/PreAuthEchs/WithoutReferral";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Badge } from "antd";

interface ReferralAcceptanceProps {
  form: any;
  visitType: any;
  loading: boolean;
  documentTypes: any[];
  documentUrls: any[];
  documentRequestResponseDocuments: any;
  handleFileChange: any;
  handleOpen: any;
  handleSaveData: () => Promise<void>;
  isSubmitting: boolean;
  preAuth: any;
  hasFunctionality: (key: string) => boolean;
  handleSaveConfirmationModal: (state: string) => void;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  activeKey: any;
  referralPresent: any;
  ageBelowSeventyWithoutReferral: any;
  ageAboveSeventyWithoutReferral: any;
  renderActionButtons: () => React.ReactNode;
  portalSubmission: any;
  uploadFileList: any;
  isIntimated: any;
  removedDiagnoses: any;
  setRemovedDiagnoses: any;
  polyclinicList?: any[];
  showVerifyButton?: boolean;
  registrationValidationStatus?: any;
  isValidationLoading?: boolean;
  handleRegistrationValidation?: any;
}

const { Panel } = Collapse;

const ReferralAcceptance: FC<ReferralAcceptanceProps> = ({
  form,
  visitType,
  loading,
  documentTypes,
  documentUrls,
  documentRequestResponseDocuments,
  handleFileChange,
  handleOpen,
  handleSaveData,
  isSubmitting,
  preAuth,
  hasFunctionality,
  handleSaveConfirmationModal,
  isApproved,
  isApprovedInitiated,
  activeKey,
  referralPresent,
  ageAboveSeventyWithoutReferral,
  ageBelowSeventyWithoutReferral,
  renderActionButtons,
  portalSubmission,
  uploadFileList,
  isIntimated,
  removedDiagnoses,
  setRemovedDiagnoses,
  polyclinicList,
  showVerifyButton,
  registrationValidationStatus,
  isValidationLoading,
  handleRegistrationValidation,
}) => {
  const { patients, auth } = useSelector((state: RootState) => state);

  const styles = React.useMemo(
    () => ({
      mainContent: {
        background: "#FFFFFF",
        borderRadius: "10px",
        padding: "20px",
        marginBottom: "20px",
      },
      saveBtn: {
        color: "white",
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
      },
      editBtn: {
        color: "#008B8B",
        background: "white",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
      },
    }),
    [],
  );

  return (
    <div>
      <div style={{display: "flex", justifyContent: "flex-end"}}>
      {registrationValidationStatus && (
        <Badge
          count={
            registrationValidationStatus?.toUpperCase() === "FAILED"
              ? "Not Verified"
              : registrationValidationStatus?.toUpperCase() === "DISCREPANCY"
                ? "MISMATCH"
                : "Verified"
          }
          style={{
            backgroundColor:
              registrationValidationStatus?.toUpperCase() === "VALIDATED"
                ? "#52c41a"
                : registrationValidationStatus?.toUpperCase() === "FAILED"
                  ? "#f5222d"
                  : registrationValidationStatus?.toUpperCase() ===
                      "DISCREPANCY"
                    ? "#f5222d"
                    : "#fca800ff",
          }}
        />
      )}
      </div>
      {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        "EMERGENCY" ||
      (patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP" &&
        !patients?.fetchBasicDetails?.referralInfoResponse?.echsReferralResponse
          ?.referralNo) ? (
        <>
          <WithoutReferral
            form={form}
            disabled={portalSubmission}
            polyclinicList={polyclinicList}
          />
          {preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
            ?.claimId ||
          preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
            ?.claimId ? (
            <></>
          ) : (
            renderActionButtons()
          )}
          {showVerifyButton ? (
            <Button
              color="cyan"
              type="primary"
              icon={<CheckCircleOutlined />}
              loading={isValidationLoading}
              style={{
                marginTop: "20px",
                marginLeft: "14px",
                cursor: "pointer",
              }}
              onClick={handleRegistrationValidation}
            >
              {preAuth?.portalData?.portalRegistrationStatus ||
              registrationValidationStatus
                ? "View"
                : "Verify"}
            </Button>
          ) : (
            <></>
          )}
        </>
      ) : (
        <Form
          form={form}
          labelAlign="left"
          layout="vertical"
          labelWrap
          style={{ width: "100%" }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                name="polyClinic"
                label="POLYCLINIC"
                // rules={[
                //   {
                //     required: ageAboveSeventyWithoutReferral ? false : true,
                //     message: "Please Input Polyclinic",
                //   },
                // ]}
              >
                <Input disabled={portalSubmission} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                name="beneficiaryId"
                label="BENEFICIARY ID"
                rules={[
                  { required: true, message: "Please input BENEFICIARY ID" },
                ]}
              >
                <Input disabled={portalSubmission} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                name="patientOpdIpdNumber"
                label="ADMISSION OPD NUMBER"
                rules={[
                  {
                    required: true,
                    message: "Please input admission opd number",
                  },
                ]}
              >
                <Input disabled={portalSubmission} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                name="referralId"
                label="REFERRAL ID"
                rules={[
                  {
                    required: ageAboveSeventyWithoutReferral ? false : true,
                    message: "Please input referral id",
                  },
                ]}
              >
                <Input
                  disabled={portalSubmission}
                  // disabled={
                  //   !(
                  //     ageAboveSeventyWithoutReferral ||
                  //     ageBelowSeventyWithoutReferral
                  //   ) || disabled
                  // }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                name="serviceNumber"
                label="SERVICE NUMBER"
                rules={[
                  {
                    required: ageAboveSeventyWithoutReferral ? false : true,
                    message: "please input service number",
                  },
                ]}
              >
                <Input disabled={portalSubmission} />
              </Form.Item>
            </Col>

            {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              name="opdDate"
              label="ADMISSION/OPD DATE/TIME"
              rules={[
                {
                  required: true,
                  message: "Please input admission opd date/time",
                },
              ]}
            >
              <DatePicker
                showTime
                format={"DD-MM-YYYY HH:mm:ss"}
                style={{ width: "100%" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col> */}

            {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="remarks"
              label="REMARKS"
              rules={[{ required: true, message: "Please input remarks" }]}
            >
              <Input placeholder="REMARKS" disabled={portalSubmission} />
            </Form.Item>
          </Col> */}

            {showVerifyButton ? (
              <Button
                color="cyan"
                type="primary"
                icon={<CheckCircleOutlined />}
                loading={isValidationLoading}
                style={{
                  marginTop: "30px",
                  marginLeft: "20px",
                  cursor: "pointer",
                }}
                onClick={handleRegistrationValidation}
              >
                {preAuth?.portalData?.portalRegistrationStatus ||
                registrationValidationStatus
                  ? "View"
                  : "Verify"}
              </Button>
            ) : (
              <></>
            )}
          </Row>

          {/* Replace the old button section with the new renderActionButtons */}
          {preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
            ?.claimId ||
          preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
            ?.claimId ? (
            <></>
          ) : (
            renderActionButtons()
          )}
        </Form>
      )}
    </div>
  );
};

export default React.memo(ReferralAcceptance);
